import { cx } from '@linaria/core';
import { mdiCloseCircle } from '@mdi/js';
import Icon from '@mdi/react';
import { useCallback } from 'react';
import { SettingsType } from '../../../../constants/enums';
import { locales } from '../../../../locales/en';
import { AlertType, UEOPT_APP_ALERT_SETTINGS_TYPES } from '../../../../mfcLogic/ueopts';
import { useSettingSelector } from '../../../Hooks/useSettings';
import { Legend } from '../../../common/Fieldset';
import FlexGrid from '../../../common/FlexGrid';
import Radio, { RadioGroup } from '../../../common/Radio';
import { SettingsRadioGroup, SettingsSection } from '../../../common/Settings';
import "./HeaderAlerts.linaria.module.css!=!./HeaderAlerts?./HeaderAlerts.linaria.module.css?css=H4sIAAAAAAAAA41TwZKjIBS8z1fkMlWZAykwxiTMZf+EIohIgmAAJUrNv2+pa6Kzc5gT1Y9+r+s1zY76ioieoC5NjSp2axgraoXUQPHC47R+fH69jYzzlXh141BF1lhnLK6N1J7b+b4tSVfc4W0fW269ZFQBqqTQ+GK8N9VMOyqCCpeYNkRmlLG4pXYLgOPM6JzaDnj+8B8z2+5J4yQrkziU/w20UpR+ZpSQyCT4NF2jeYuRi7PXGupGUBEeuuXfYKxpnkstpsVRsmhRS4knejb8p5H3BO1VkGn/DUZhZQ48r2pFPQfMqKbSDjOq2BZB+L4BG5TA+vExHU/rHUGoPoQCxly6WtEOD4Pma3YiAYm2u6xRLIz2wMmeY7Qfh/2peC7pZlvRBwgy9yXenLNBLo6dKDT3qzmt/PlFbakzuvaj0CF5CfXmqG4tQe5W0qv5XWmpgiaVkXVKSeGFVMkaxclbIGiNTy8nh/S5LvTGrdKXWxq4BYpeuHpmz58J1SK4bMqet1S7wtgKN3XNLaOOz8yCoDIz16ZfozjGFTCjPdceM776Lh1Bxt1N0sbJoeH9ly/q+SEr12jhAdwdLX9+KuaIlkcFxRpN/MCnfEL4+fX2F3uAJUP8AwAA"
const cancelIconStyles = "atm_gz_1y44olf atm_9j_tlke0l atm_vh_yfq0k3 atm_7l_1fs2ovw";
const clearAlertLabelStyles = "atm_r3_usich2 atm_9j_tlke0l atm_h0_i2wt44 atm_7l_1fs2ovw";
const formStyles = "atm_lk_1fwxnve atm_ll_i2wt44";
const stylesInnerGrid = "atm_dz_13lwi4z atm_9s_11p5wf0";
const formControlStyles = "atm_c8_w1gvyb atm_1wuqjo8_1fwxnve atm_zo7lkv_1skhajo";
const radioOptionStyles = "atm_84_ftgil2";
const titleStyles = "atm_7l_1sywzos atm_t9_angws6 atm_f_1h6ojuz atm_vy_1osqo2v atm_c8_wte56h atm_cs_ni7l0g";
const alertOptions = [{
  value: UEOPT_APP_ALERT_SETTINGS_TYPES[AlertType.STATUS].bit,
  label: locales.friends.onlineNotifications,
  'data-testid': 'FriendsAlerts__OnlineNotifications'
}, {
  value: UEOPT_APP_ALERT_SETTINGS_TYPES[AlertType.NEWS].bit,
  label: locales.friends.news,
  'data-testid': 'FriendsAlerts__News'
}, {
  value: UEOPT_APP_ALERT_SETTINGS_TYPES[AlertType.ALL].bit,
  label: locales.friends.both,
  'data-testid': 'FriendsAlerts__Both'
}, {
  value: UEOPT_APP_ALERT_SETTINGS_TYPES[AlertType.OFF].bit,
  label: locales.friends.none,
  'data-testid': 'FriendsAlerts__None'
}];
interface HeaderAlertSettingProps {
  embedded?: 'vertical';
  clearAlerts?(): void;
}
export const HeaderAlertSettings = (props: HeaderAlertSettingProps) => {
  const [alertsSettings, saveAlertsSettings] = useSettingSelector(SettingsType.DEFAULT, 'alerts');
  const {
    embedded,
    clearAlerts
  } = props;
  const setAlertsSettings = useCallback((value: 0 | 1 | 2 | 4) => {
    saveAlertsSettings(value);
  }, []);
  const handleChange = useCallback(event => {
    const {
      target
    } = event;
    setAlertsSettings(target.value);
  }, [alertsSettings]);
  if (embedded === 'vertical') {
    return <SettingsSection title={locales.friends.alerts}>
                <SettingsRadioGroup name="headerAlerts" value={Number(alertsSettings)} onChange={value => setAlertsSettings(value as 0 | 1 | 2 | 4)} options={alertOptions} />
            </SettingsSection>;
  }
  return <FlexGrid className={formStyles}>
            <div className={formControlStyles}>
                <div className={cx(clearAlerts && stylesInnerGrid)}>
                    <Legend className={titleStyles}>
                        {locales.friends.alerts}
                    </Legend>
                    {clearAlerts && <Legend className={cx(clearAlertLabelStyles, titleStyles)} onClick={clearAlerts}>
                            {locales.friends.clearAlerts}{' '}
                            <Icon path={mdiCloseCircle} size="1.25rem" data-testid={`ClearAlerts__Icon`} className={cancelIconStyles} />
                        </Legend>}
                </div>
                <RadioGroup row onChange={handleChange} value={alertsSettings} name="headerAlerts">
                    {alertOptions.map(option => <Radio small dense key={option.value} className={radioOptionStyles} controlTestId={option['data-testid']} value={option.value} label={option.label} />)}
                </RadioGroup>
            </div>
        </FlexGrid>;
};